import React, { forwardRef, useId } from 'react'
import { Switch } from 'antd'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction } from 'react'
import type { LntSwitchProps } from './types'

const Component: ForwardRefRenderFunction<HTMLInputElement, LntSwitchProps> = (props, ref) => {
  const { className: outerClassName, id: outerId, children, ...restProps } = props

  const innerId = useId()
  const id: string = outerId ?? innerId
  const className: string = classNames(styles.lntSwitch, outerClassName)

  return (
    <label
      htmlFor={ id }
      className={ className }
    >
      <Switch
        { ...restProps }
        id={ id }
        ref={ ref }
      />

      { children }
    </label>
  )
}

export const LntSwitch = forwardRef<HTMLInputElement, LntSwitchProps>(Component)
